/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';

@Injectable({
    providedIn: 'root'
})
export class CustomFieldGroupService {

    customFieldsDataType = {
        SINGLE_LINE: 'TEXT',
        MULTI_LINE: 'TEXTAREA',
        SINGLE_ITEM: 'DROPDOWN',
        RADIO: 'RADIO',
        MULTI_ITEM: 'CHECKBOX',
        NUMBER: 'NUMBER',
        DATE: 'DATE',
        TIME: 'TIME',
        DATETIME: 'DATETIME',
        LOOKUP: 'LOOKUP',
        TEXT: 'TEXT',
        DROPDOWN: 'DROPDOWN'
    };

    constructor(private dataCollectorService: DataCollectorService) { }

    getModuleCustomFieldsUrl(moduleName: string): string {
        return `${this.dataCollectorService.baseurl()}/settings/custom_fields?original_template=true&module_name=${moduleName}`;
    }

    getCustomFieldGroups(masterCustomFields: any[], customFields: any[]): any {
        const customFieldGroups: any = {};
        const groupObj: any = { 'default_group': 0 };
        let maxOrderNo: number = 0;
        const reorderedCustomFields: any[] = [];

        masterCustomFields?.forEach((value: any) => {
            if (value.group) {
                groupObj[value.group.group_name] = value.group.order_no;
            }
            if (value.group && maxOrderNo < value.group.order_no) {
                maxOrderNo = value.group.order_no;
            }
            //Adding the custom fields in new array based on master custom fields index
            const hasField: any = customFields.find(field => field?.label === value?.field_name && value?.group?.group_uid === field?.group_uid);
            if (hasField) {
                reorderedCustomFields.push(hasField);
            }
            return value;
        });

        customFields?.forEach((value: any) => {
            if (value.group_name && groupObj[value.group_name] === undefined) {
                groupObj[value.group_name] = ++maxOrderNo;
            }
            //Adding the custom fields in last index which is not available in master custom fields
            if (!reorderedCustomFields.find(field => field?.label === value?.label && value?.group_uid === field?.group_uid)) {
                reorderedCustomFields.push(value);
            }
        });

        reorderedCustomFields?.forEach((value: any) => {
            const groupName: string = value.group_name || 'default_group';
            value.group = {
                'group_name': groupName,
                'group_uid': value.group_uid ? value.group_uid : '',
                'order_no': groupObj[groupName] ?? 0,
                'label_name': 'Default'
            };

            masterCustomFields?.forEach((masterCustomField: any) => {
                const isSameGroup = masterCustomField.group?.group_name === value.group.group_name;
                const isSameField = masterCustomField.field_name ===  value.label;

                if ((masterCustomField.hasOwnProperty('group') && value.hasOwnProperty('group') && isSameGroup && isSameField) ||
                    (masterCustomField.original_template?.group === value.group.label_name && isSameField)) {
                    value.hide_field = masterCustomField.hide_field;
                    value.hide_to_fe = masterCustomField.hide_to_fe;
                    value.is_dependent = masterCustomField.is_dependent;
                    value.dependent_on = masterCustomField.dependent_on;
                    value.dependent_options = masterCustomField.dependent_options;
                }
            });

            if (!customFieldGroups[value.group.order_no]) {
                const isDefaultGroup: boolean = groupName === 'default_group';
                customFieldGroups[value.group.order_no] = {
                    'headerName': isDefaultGroup ? 'Other Details' : groupName,
                    'custom_fields': [],
                    'isDefaultGroup': isDefaultGroup
                };
            }
            customFieldGroups[value.group.order_no].custom_fields.push(value);
            return value;
        });
        return customFieldGroups;
    }

    getMasterCustomFieldGroups(masterCustomFields: any[]): any {
        const masterCustomFieldsgrouped = {};
        masterCustomFields.forEach((element: any) => {
            if (element?.group?.order_no) {
                if (masterCustomFieldsgrouped[`${element?.group?.order_no}`]) {
                    masterCustomFieldsgrouped[`${element?.group?.order_no}`].push(element);
                } else {
                    masterCustomFieldsgrouped[`${element?.group?.order_no}`] = [element];
                }
            } else {
                if (masterCustomFieldsgrouped['0']) {
                    masterCustomFieldsgrouped['0'].push(element);
                } else {
                    masterCustomFieldsgrouped['0'] = [element];
                }
            }
        });
        const sortedMasterCustomFields = {};
        Object.keys(masterCustomFieldsgrouped).sort().forEach((element: any) => {
            sortedMasterCustomFields[element] = masterCustomFieldsgrouped[element];
        });
        return sortedMasterCustomFields;
    }

    constructCustomFieldUpdateObject(responseData: any): Array<any> {
        const customFieldsObj = this.getMasterCustomFieldGroups(responseData);
        const result = [...Object.keys(customFieldsObj).map((data: any) =>
            customFieldsObj[data].map((field: any) => ({
                label: field?.field_name,
                field_options: this.customFieldsDataType[field?.field_type] === 'CHECKBOX' ?
                    field?.field_options.map((opt: any) => ({ key: opt, value: opt, checked: false })) :
                    field?.field_options.map((opt: any) => ({ key: opt, value: opt })) || [],
                type: this.customFieldsDataType[field?.field_type] || 'TEXT',
                group_name: data === '0' ? 'Custom fields - Default' : `Custom fields - ${field?.group?.group_name}`,
                group_uid: field?.group?.group_uid || '',
                order_no: Number(data),
                field_type: field?.field_type,
                read_only: field?.read_only,
                hide_to_fe: field?.hide_to_fe,
                hide_field: field?.hide_field
            }))
        )].flat(1);

        return result;
    }
}
